module.exports = __webpack_public_path__ + "img/rotates.eb333b0f.png";